module.exports = __webpack_public_path__ + "/images/ico-nav-newlist.fc1760b.png";